import type { AskInChatOptions } from "#types/AskInChatOptions.ts";
import { create } from "zustand";

interface AskInChatStore {
    askInChatOptions?: AskInChatOptions;
    setAskInChatOptions: (options?: AskInChatOptions) => void;
    reset: () => void;
}

export const useAskInChatStore = create<AskInChatStore>()((set, _, store) => ({
    askInChatOptions: undefined,
    setAskInChatOptions: askInChatOptions => set({ askInChatOptions }),
    reset: () => set(store.getInitialState())
}));
